import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import FooterLogo from "../../assets/Transparent Logo 1.png";

const FooterNavLink = ({ to, children, onClick }) => (
  <Link
    to={to}
    onClick={onClick}
    className="font-medium font-inter text-[10px] sm:text-[12px] md:text-[14px] lg:text-level-5 text-header-text"
  >
    {children}
  </Link>
);

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleScrollLink = (sectionId) => {
    const offset = 100;

    if (location.pathname !== "/") {
      navigate("/", { replace: false });
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        window.scrollTo({
          top: section.offsetTop - offset,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <footer className="px-4 pt-2 pb-4 bg-footer md:px-20 md:pt-6 ">
      <div className="flex flex-col items-center justify-between gap-0 md:flex-row ">
        {/* Logo */}
        <div
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="w-[100px] sm:w-[116px] md:w-[132px] lg:w-[148px] cursor-pointer"
        >
          <img
            src={FooterLogo}
            alt="Tenafix Logo"
            className="w-full h-auto relative lg:left-[-30px] bottom-[0px]"
          />
        </div>

        {/* Navigation Links */}
        <div className="flex flex-wrap justify-center space-x-4 md:space-x-8 md:justify-end ">
          <FooterNavLink
            to="/"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Home
          </FooterNavLink>
          {/* <FooterNavLink to="/taskers">Taskers</FooterNavLink> */}
          <FooterNavLink to="/" onClick={() => handleScrollLink("aboutus")}>
            About Us
          </FooterNavLink>
          <FooterNavLink to="/" onClick={() => handleScrollLink("contactus")}>
            Contact Us
          </FooterNavLink>
        </div>
      </div>

      {/* Divider */}
      <div className="w-full h-[1px] bg-footer-divider mb-4 mt-0" />

      {/* Copyright */}
      <div className="flex flex-col items-center justify-between gap-2 md:flex-row">
        <div className="font-medium  text-[8px] sm:text-[10px] md:text-[12px] lg:text-level-6 font-inter text-footer-text">
          Tenafix Ltd. ©All Rights Reserved
        </div>
        <div>
          <div className="flex flex-wrap justify-center space-x-4 md:space-x-8 md:justify-end">
            <p className="font-medium  text-[8px] sm:text-[10px] md:text-[12px] lg:text-level-6 font-inter text-footer-text cursor-pointer"onClick={() => navigate('/terms-and-conditions')}>
              Terms & Conditions
            </p>
            <p className="font-medium  text-[8px] sm:text-[10px] md:text-[12px] lg:text-level-6 font-inter text-footer-text cursor-pointer"onClick={() => navigate('/privacy-policy')}>
              Privacy Policy
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
